module.exports = __webpack_public_path__ + "static/zoom-5db5dcb912e7cdba4e3d0265cf52e52d.png";